//@flow
import React, { useState } from 'react';
import type { VersionType } from 'types/product';
import { find } from 'lodash';
import { FloorPlanInfo } from 'components/molecules/floorPlanInfo';
import { FloorPlan } from 'components/molecules/floorPlan';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';
import { PdfButton } from 'components/atoms/pdfButton';

type Props = {
  versions: Array<VersionType>,
  productName: string,
};
export const ProductVersions = (props: Props) => {
  const { height } = useViewport();
  const { versions, productName, pdfUrl, type } = props;
  const [selectedVersion, setVersion] = useState(versions[0]);

  const onSelectVersion = selectedId => {
    const updateVersion = find(versions, { id: selectedId });
    setVersion(updateVersion);
  };

  return (
    <div
      className={'section-container variations-container'}
      style={{ height }}
    >
      <div className={'plan-info-container'}>
        <FloorPlanInfo
          versions={versions}
          selectedVersion={selectedVersion}
          onClick={onSelectVersion}
          type={type}
        />
        {pdfUrl && pdfUrl && (
          <PdfButton
            mode={'light'}
            className={'pdf-Button'}
            text={'DOWNLOAD SPECIFICATIONS'}
            onClick={() => window.open(pdfUrl, '_blank')}
          />
        )}
      </div>
      <div className={'plan-image-container'}>
        <FloorPlan version={selectedVersion} productName={productName} type={type}/>
      </div>
    </div>
  );
};
